import { useQuery } from '@tanstack/react-query';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi';

export function useGetTherapeuticIndicationsForHcp(hcpId: number | undefined, enabled: boolean = true) {
    return useQuery({
        queryKey: ['therapeuticIndicationsForHcp', hcpId],
        queryFn: () => hcpId ? HealthcareFacilitiesApi.getTherapeuticIndicationsForHcp(hcpId) : Promise.resolve([]),
        enabled: enabled && hcpId !== undefined,
    });
}
